import { Box, Container, Paper } from '@mui/material';
import LoginForm from '@components/auth/LoginForm';

const LoginPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: { xs: 'background.paper', sm: 'background.default' },
        py: { xs: 2, sm: 4 },
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={{ xs: 0, sm: 3 }}
          sx={{
            p: { xs: 2.5, sm: 4 },
            borderRadius: { xs: 2, sm: 2 },
          }}
        >
          <LoginForm />
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginPage;
